import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessageWrappedInSpan } from '../../misc';

import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';

import CustomDialog from './CustomDialog';

import { sendError } from '../../../appsignal';

const ErrorDialog = props => {
  const { open, error, onRequestClose } = props;

  if (error) {
    return (
      <CustomDialog open={open} onRequestClose={onRequestClose}>
        <div className="notification-container">
          <DialogContent>
            <div className="notification-body">
              <ErrorDialogBody error={error} />
            </div>
          </DialogContent>
          <DialogActions>
            <div className="notification-action">
              <button className="accept" onClick={onRequestClose}>
                <FormattedMessageWrappedInSpan id="errorDialog.okButton" defaultMessage="OK" />
              </button>
            </div>
          </DialogActions>
        </div>
      </CustomDialog>
    );
  }

  return null;
};

ErrorDialog.propTypes = {
  open: PropTypes.bool,
  error: PropTypes.object,
  onRequestClose: PropTypes.func,
};

const ErrorDialogBody = ({ error }) => {
  const lowerCaseMsg = error.message.toLowerCase();
  if (lowerCaseMsg.includes('failed to fetch')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.failedToFetch"
        defaultMessage="The server didn't respond. You may retry your request when the server comes back up."
      />
    );
  } else if (lowerCaseMsg.includes('token_expired')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.magicLinkExpired"
        defaultMessage="The Magic Link you are using to try to login is expired. Please request a new one."
      />
    );
  } else if (lowerCaseMsg.includes('send_failed')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.failedToSendEmail"
        defaultMessage="An error occurred while sending the email. Please try again later."
      />
    );
  } else if (lowerCaseMsg.includes('has already been taken')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.duplicateItemInCart"
        defaultMessage="This item is already in your cart"
      />
    );
  } else if (lowerCaseMsg.includes('incompatible line item price currency')) {
    return (
      <FormattedMessageWrappedInSpan
        id="errorDialogBody.differentCurrenciesInCart"
        defaultMessage="Your cart can not have different currencies"
      />
    );
  }

  // By default send the unknown error to Appsignal and show the user a default
  // message
  sendError(error);
  return (
    <FormattedMessageWrappedInSpan
      id="errorDialogBody.unknowError"
      defaultMessage="Un unknow error has occured"
    />
  );
};

ErrorDialogBody.propTypes = {
  error: PropTypes.object,
};

export default ErrorDialog;
